import { __assign } from "tslib";
import LAYOUTS from '../../common/constants/layout';
import SCROLL_DIRECTION from '../../common/constants/scrollDirection';
import { calcTargetItemSize, processNumberOfImagesPerRow, processGridStyle, } from '../helpers/layoutHelper';
import { featureManager } from '../helpers/versionsHelper';
var fixToMasonry = function (options) {
    var presetOptions = __assign({}, options);
    presetOptions.galleryLayout = LAYOUTS.MASONRY;
    presetOptions.cubeImages = false;
    presetOptions.scrollDirection = SCROLL_DIRECTION.VERTICAL;
    presetOptions.groupSize = 1;
    presetOptions.groupTypes = '1';
    presetOptions.slideshowLoop = false;
    presetOptions.enableScroll = true;
    presetOptions.cropOnlyFill = false;
    return presetOptions;
};
export var fixedOptions = fixToMasonry({});
export var createOptions = function (options) {
    var res = __assign({}, options);
    res = fixToMasonry(res);
    res.targetItemSize = calcTargetItemSize(res, res.isVertical ? res.gallerySize * 8 + 200 : res.gallerySize * 5 + 200);
    if (featureManager.supports.fixedColumnsInMasonry) {
        res = processNumberOfImagesPerRow(res);
    }
    res = processGridStyle(res);
    return res;
};
//# sourceMappingURL=masonryGallery.js.map